import { render, staticRenderFns } from "./ExportBtn.vue?vue&type=template&id=a86b9df2&scoped=true"
import script from "./ExportBtn.vue?vue&type=script&lang=js"
export * from "./ExportBtn.vue?vue&type=script&lang=js"
import style0 from "./ExportBtn.vue?vue&type=style&index=0&id=a86b9df2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86b9df2",
  null
  
)

export default component.exports